import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { RouteBean } from '../model/RouteBean';
import { AdministrationService } from '../services/route-service';
import { PrimeNGConfig } from 'primeng/api';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { RouteBeanToSave } from '../model/RouteBeanToSave';

@Component({
  selector: 'app-edit-route',
  templateUrl: './edit-route.component.html',
  styleUrls: ['./edit-route.component.css'],
})
export class EditRouteComponent {

  @Input() infRef: RouteBean;
  @Input() newInref: boolean;
  @Input() administration: RouteBean[];
  @Input() validFromDateMap: Map<string, Date>;
  @Input() validToDateMap= new Map<string, Date>();
  @Input() changedDate: string;
  copyref: RouteBean;
  copyField: boolean;
  profileForm: FormGroup;
  heading: any;
  minimumDate:Date = new Date();
  systemNames: Array<string> = [];
  systemUUIDMap = new Map<string, string>();
  channelTypes: any;
  emneArray: Array<string>=[];
  emneOldMapArray= new Map<string, string>();
  isEditSubjectPresent: boolean = false;
  isDateOverlapped: boolean =false;
  isDateRangeValid: boolean =false;
  isEnable: boolean;
  validFromErrorMessage: string;
  validToErrorMessage: string;
  tempCopyObj: { id: string,systemName:string, kleEmne: string, handlingFacet: string };
  isAddSubjectPresent: boolean = false;
  visible: boolean = false;
  alertmessage: string='';
  finalAddArray: { id: string,systemName:string, kleEmne: string, handlingFacet: string }[] = [];
  regexPattern = /^\d{2}\.(\d{2}|\*)\.(\d{2}|\*)$/;
  regexPattern2 = /^[A-ZÆØÅ]{1}\d{2}$/;
  constructor(private adminService: AdministrationService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private primengconfig : PrimeNGConfig,
    private authenticationservice : AuthenticationService,
    private fb: FormBuilder) {
    this.profileForm = this.fb.group
      ({
        title: new FormControl('', Validators.required),
        channelType: new FormControl('', Validators.required),
        kleEmne: new FormControl('', [Validators.required, Validators.pattern(this.regexPattern)]),
        handlingFacet: new FormControl('', [Validators.required, Validators.pattern(this.regexPattern2)]),
        validFrom: new FormControl('', Validators.required),
        validTo: new FormControl('', Validators.required),
        systemName: new FormControl('', Validators.required)
      });

   // To disable alert
    this.profileForm.valueChanges.subscribe(
        result => {
          if(this.visible){
            this.visible=false;
            this.isDateRangeValid = false;
          }
        }
    );
  }
  ngOnInit() {
    this.isEnable = this.authenticationservice.canUserEdit();
    if(!this.isEnable)
    {
      this.profileForm.disable();
    }
    
    this.primengconfig.ripple = true;
    var system = this.infRef.systemName;
    this.infRef.systemName='';
    this.adminService.getuserSystems().then(data => {
      data.forEach(value=>{
         this.systemNames.push(value.name);
         this.systemUUIDMap.set(value.name,value.uuid);
        });   
        this.infRef.systemName =system;
     });
    this.adminService.getchannelTypes().then(data => {
      const newArray = this.removeDuplicatesExcludeWord(data, 'DIGITALPOST');
      this.channelTypes= newArray;
      if(newArray.length == 1)
      {
        this.infRef.channelType= newArray[0]; 
      }
    });
    if (this.infRef.systemUUID && !this.copyField) {
      var obj =
      {
        "id": this.infRef.id as string,
        "systemName": system as string,
        "kleEmne": this.infRef.kleEmne as string,
        "handlingFacet": this.infRef.handlingFacet as string
      };
      this.tempCopyObj = obj;
    }
    else
    {
      this.changedDate ="";
    }
  }
  ngOnChanges() {
    if (this.infRef) {
      this.heading = this.infRef.title;
    }
  }

removeDuplicatesExcludeWord(array: string[], wordToExclude: string): string[] {
  const encountered: Map<string, boolean> = new Map();
  return array.filter((item: string) => {
    const isDigital: boolean = item.toLowerCase() === wordToExclude.toLowerCase();
    const lowerCaseItem: string = item.toLowerCase();
    // Case-sensitive check for duplicates
    const isDuplicate: boolean = encountered.has(lowerCaseItem);
    if (!isDigital && !isDuplicate) {
      encountered.set(lowerCaseItem, true);
      return true;
    }
    return false;
  });
  }
 
  @Output() cancelClickEvent = new EventEmitter<boolean>();
  @Output() submitClickedEvent = new EventEmitter<boolean>();
  submitClicked(el: HTMLElement) {
    this.profileForm.markAsDirty();
    this.profileForm.markAllAsTouched();
    if (
      this.profileForm.invalid
    ) {
      return; 
    }
    var overlappedIds="|";
    if (this.infRef.id && !this.copyField) {
      this.emneOldMapArray.clear();
      this.administration.forEach((administration) => {
        const editArray =
        {
          "id": administration.id as string,
          "kleEmne": administration.kleEmne as string,
          "handlingFacet": administration.handlingFacet as string
        };
        if (this.infRef.id !== editArray.id) {

          if((administration.handlingFacet == this.infRef.handlingFacet) && administration.systemName?.toLowerCase() == this.infRef.systemName?.toLowerCase())
          {
            this.emneOldMapArray.set(administration.id as string,administration.kleEmne as string);
          }
          
          if((this.validFromDateMap.get(administration.id as string) as Date  <= new Date(this.infRef.validTo as Date)) && (this.validToDateMap.get(administration.id as string) as Date >= new Date(this.infRef.validFrom as Date)))
          {
            overlappedIds = overlappedIds+ administration.id +"|";
          }
        }
      });
      var kleEmneVal='';
      var isSecndDigitEqual=false;
      var subject='';
      this.emneOldMapArray.forEach((value:string,key:string)=>{
        kleEmneVal = this.infRef.kleEmne as string;
        var str = this.infRef.kleEmne?.substring(0, 2);
       
        if (value.startsWith(str as string)) {
           if(kleEmneVal.substring(2,4) =='.*' || value.substring(2,4)=='.*' )
           {
              subject = key;
              this.isEditSubjectPresent = true;
           }
           else if(kleEmneVal.substring(3,5) == value.substring(3,5))
           {
              isSecndDigitEqual = true;
           }
           
           if((kleEmneVal.substring(5,7) =='.*' || value.substring(5,7)=='.*') && isSecndDigitEqual == true)
           {
              subject = key;
              this.isEditSubjectPresent = true;
           }
           else if((kleEmneVal.substring(6,8) == value.substring(6,8))  && isSecndDigitEqual == true)
           {
              subject = key;
              this.isEditSubjectPresent = true;
           }
          
        }
        if(this.isEditSubjectPresent == true && overlappedIds.includes(subject))
        {
          overlappedIds ="|";
          this.isDateOverlapped = true;
          return;
        }
          
      }); 
      if (this.isEditSubjectPresent == true && this.isDateOverlapped == true) 
      {
        this.visible = true;
        this.alertmessage = 'Fejl: Der er en eksisterende routingsregel med overlappende Kanaltype, Handlingsfacet, Emne og tidsrum';
        this.isEditSubjectPresent = false;
        this.isDateOverlapped = false;
        el.scrollIntoView();
      }
      else if(this.isDateRangeValid == false ) {
        let routeToAdd = new RouteBeanToSave(this.infRef)
        routeToAdd.validFrom = this.FormatDateToSave(this.infRef.validFrom as Date);
        routeToAdd.validTo = this.FormatDateToSave(this.infRef.validTo as Date);
        routeToAdd.changedDate = this.FormatDateToSave(this.infRef.changedDate as Date);

        routeToAdd.systemUUID = this.systemUUIDMap.get(this.infRef.systemName as string);
        this.adminService.updateInfref(routeToAdd).then(data => {
          this.submitClickedEvent.emit(true);
        })
      }
    }
    else {
      if(!this.copyField)
      {
        this.emneOldMapArray.clear();
      }
      
      this.administration.forEach((administration) => {
        const addArray =
        {
          "id": administration.id as string,
          "kleEmne": administration.kleEmne as string,
          "handlingFacet": administration.handlingFacet as string
        };
        if(administration.id !== ''){
          if((administration.handlingFacet == this.infRef.handlingFacet) && administration.systemName?.toLowerCase() == this.infRef.systemName?.toLowerCase())
          {
            this.emneOldMapArray.set(administration.id as string,administration.kleEmne as string);
          }
          
          if((this.validFromDateMap.get(administration.id as string) as Date  <= new Date(this.infRef.validTo as Date)) && (this.validToDateMap.get(administration.id as string) as Date >= new Date(this.infRef.validFrom as Date)))
          {
            overlappedIds = overlappedIds+ administration.id +"|";
          }
        }
      });
      if(this.copyField)
      {
        this.finalAddArray.forEach((data)=>{
          if((data.handlingFacet == this.infRef.handlingFacet) && data.systemName?.toLowerCase() == this.infRef.systemName?.toLowerCase())
          {
            this.emneOldMapArray.set(data.id,data.kleEmne as string);
            if((this.validFromDateMap.get(data.id as string) as Date  <= new Date(this.infRef.validTo as Date)) && (this.validToDateMap.get(data.id as string) as Date >= new Date(this.infRef.validFrom as Date)))
            {
              overlappedIds = overlappedIds+ data.id +"|";
            }
          }
        })
      }
      
      var kleEmneVal='';
      var isSecndDigitEqual=false;
      var subject='';
      this.emneOldMapArray.forEach((value:string,key:string)=>{
        kleEmneVal = this.infRef.kleEmne as string;
        var str = this.infRef.kleEmne?.substring(0, 2);
       
        if (value.startsWith(str as string)) {
           if(kleEmneVal.substring(2,4) =='.*' || value.substring(2,4)=='.*' )
           {
              subject = key;
              this.isAddSubjectPresent = true;
           }
           else if(kleEmneVal.substring(3,5) == value.substring(3,5))
           {
              isSecndDigitEqual = true;
           }
           
           if((kleEmneVal.substring(5,7) =='.*' || value.substring(5,7)=='.*') && isSecndDigitEqual == true)
           {
              subject = key;
              this.isAddSubjectPresent = true;
           }
           else if((kleEmneVal.substring(6,8) == value.substring(6,8))  && isSecndDigitEqual == true)
           {
              subject = key;
              this.isAddSubjectPresent = true;
           }
        }
        if(this.isAddSubjectPresent == true && overlappedIds.includes(subject))
        {
          overlappedIds ="|";
          this.isDateOverlapped = true;
          return;
        }
      }); 
      if(this.isAddSubjectPresent == true && this.isDateOverlapped == true)
      {
        this.visible = true; 
        this.alertmessage = 'Fejl: Der er en eksisterende routingsregel med overlappende Kanaltype, Handlingsfacet, Emne og tidsrum';
        this.isAddSubjectPresent = false;
        this.isDateOverlapped = false; 
        el.scrollIntoView();
      }
      else if(this.isDateRangeValid == false) {
        this.finalAddArray =[]; 
        let routeToAdd = new RouteBeanToSave(this.infRef)
        routeToAdd.validFrom = this.FormatDateToSave(this.infRef.validFrom as Date);
        routeToAdd.validTo = this.FormatDateToSave(this.infRef.validTo as Date); 
        routeToAdd.systemUUID = this.systemUUIDMap.get(this.infRef.systemName as string);
        this.adminService.addInfRef(routeToAdd).then(data => {
          this.submitClickedEvent.emit(true);
        })
      }
    }
  }


  cancelClick() {
    this.cancelClickEvent.emit(true);
  }

  copyClick() {
    this.infRef.id = '';
    this.visible=false;
    this.copyref = this.infRef;
    this.finalAddArray.push(this.tempCopyObj);
    this.copyField = true;
  }


  deleteClick() {
    this.confirmationService.confirm({
      message:
        'Er du sikker på at du ønsker at slette den valgte fordelingsregel?',
      header: 'Slet fordelingsregel',
      rejectLabel: 'Nej',
      acceptLabel: 'Ja',

      accept: () => {
        this.adminService.deleteInfref(this.infRef.id).then(data => {
          this.submitClickedEvent.emit(true);
        })
      },
    });
  }

  moveDate() {
    const date1 = new Date(this.infRef.validFrom as Date);
    const date2 = new Date(this.infRef.validTo as Date);
    if ((date1 !== null && date2 !== null) && date1.valueOf() > date2.valueOf()) {
      this.isDateRangeValid = true;
      this.validFromErrorMessage = "Fejl: Angiv en dato efter 'Gyldig fra' datoen";
      this.validToErrorMessage ="Fejl: Angiv en dato før 'Gyldig til' datoen";
    }
   else{
      this.isDateRangeValid = false;
   }
  }

  FormatDateToSave(dateString: Date): string {
     const dateStringToSave = new Date(dateString).getFullYear() + '-' +String(new Date(dateString).getMonth() + 1).padStart(2, '0') + '-' +String(new Date(dateString).getDate()).padStart(2,'0');
     return dateStringToSave;
  }
  
}
